import {connect} from 'react-redux';
import fullContentPath from 'rlink-router/fullContentPath';
import getContentMetaIndex from 'rlink-router/getContentMetaIndex';
import getCurrentLocale from 'rlink-router/getCurrentLocale';

const connectToPathForContent = connect(({routing}) => ({
  pathForContent: path => fullContentPath(path, getContentMetaIndex(routing), getCurrentLocale(routing), routing.useLongCaches, routing.contentRoot, routing.defaultLocale),
}));

export default connectToPathForContent;



// WEBPACK FOOTER //
// ./lib/rlink-repos/connectToPathForContent.js